const e=({height:e,src:r,width:t})=>{if(r)return r.replace("{w}",t).replace("{h}",e)};export{e as replaceImageSize};
